export const preventNumberEvents = (event, type = 'keydown') => {
  switch (type) {
    case 'wheel':
      return event.wheelDeltaY < 0 ? event.preventDefault() : null
    case 'keydown':
      return event.key === '-' || event.key === '+' || event.key === 'e' || event.key === '.' || event.key === ',' || event.key === 'ArrowDown'
        ? event.preventDefault()
        : null
    default:
      return null
  }
}

export const formatMoney = (value) => {
  let formattedString = typeof value === 'string' ? value : parseFloat(value).toFixed(2).toString()
  formattedString = formattedString.replaceAll('.', '').replaceAll(',', '').replace(/\D/g, '')
  const stringLength = formattedString.length
  const integerPart = stringLength > 2 ? parseInt(formattedString.substring(0, stringLength - 2)).toLocaleString('pt-BR') : 0
  const floatPart = stringLength >= 2 ? formattedString.substring(stringLength - 2) : '00'
  return `${integerPart},${floatPart}`
}
